
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 175 175","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M106.25 68.75h56.25c6.906 0 12.5 5.563 12.5 12.5v81.25c0 6.906-5.563 12.5-12.5 12.5H81.25c-6.906 0-12.5-5.563-12.5-12.5v-56.25H12.5c-6.906 0-12.5-5.563-12.5-12.5V12.5C0 5.594 5.563 0 12.5 0h81.25c6.906 0 12.5 5.563 12.5 12.5v56.25zm0 12.5v12.5c0 6.906-5.563 12.5-12.5 12.5h-12.5v50.006a6.242 6.242 0 006.244 6.244h68.756a6.244 6.244 0 006.244-6.244V87.5a6.244 6.244 0 00-6.244-6.244h-50v-.006zM12.5 18.744V87.5a6.242 6.242 0 006.244 6.244H87.5a6.244 6.244 0 006.244-6.244V18.75a6.244 6.244 0 00-6.238-6.25H18.75a6.244 6.244 0 00-6.25 6.244zM25 66.456V35.031h22.019V21.875h9.131c1.25.181 1.881.356 1.881.538-.032.284-.124.559-.268.806-.538 1.431-.807 3.131-.807 5.1v6.712h23.369V65.65h-9.938v-4.031h-13.43v23.1h-9.67v-23.1H34.132v4.837H25zm9.125-23.9V54.37h13.163V42.563H34.13l-.006-.007zM70.388 54.37V42.563H56.956v11.812h13.431v-.006zM110.2 149.68H100L117.994 100h12.625l17.45 49.688H137.33l-3.762-10.482h-19.606l-3.757 10.475h-.006zm6.45-18.8h14.231l-6.712-21.212h-.269l-7.25 21.212zM162.5 50H150c0-13.807-11.193-25-25-25V12.5c20.71 0 37.5 16.79 37.5 37.5zm-150 75H25c0 13.807 11.193 25 25 25v12.5c-20.71 0-37.5-16.79-37.5-37.5z","fill-rule":"nonzero"}})])
          )
        }
      }
    